import { __extends } from "tslib";
import * as React from 'react';
import classNames from 'classnames';
import s from './ProductImage.scss';
import { WixMedia } from '../WixMedia';
import { getMediaUrl, } from '@wix/wixstores-client-core';
import * as _ from 'lodash';
import { DEFAULT_DIMENSION } from '../OldProductThumbnail/OldProductThumbnail';
export var DataHook;
(function (DataHook) {
    DataHook["containerDataHook"] = "containerDataHook";
    DataHook["imgDataHook"] = "imgDataHook";
})(DataHook || (DataHook = {}));
var ProductImage = /** @class */ (function (_super) {
    __extends(ProductImage, _super);
    function ProductImage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { imageLoaded: false };
        _this.getMediaUrl = function (mediaItem, requiredDimensions, isSSR, jpgExperiment, isSEOBot) {
            if (isSSR === void 0) { isSSR = false; }
            if (jpgExperiment === void 0) { jpgExperiment = false; }
            if (isSEOBot === void 0) { isSEOBot = false; }
            var imageMode = _this.props.imageMode;
            var options = { isSSR: isSSR, imageMode: imageMode, asJpg: isSSR && jpgExperiment, isSEOBot: isSEOBot };
            return getMediaUrl(mediaItem, requiredDimensions || mediaItem, options);
        };
        _this.onImageLoad = function () {
            //eslint-disable-next-line @typescript-eslint/unbound-method
            var _a = _this.props.imageLoaded, imageLoaded = _a === void 0 ? _.noop : _a;
            imageLoaded();
            _this.setState({ imageLoaded: true });
        };
        _this.getDimensions = function (mediaItem, dimensions) {
            var aspectRatio = mediaItem.width / mediaItem.height;
            return {
                width: dimensions.width || (dimensions.height ? aspectRatio * dimensions.height : null) || DEFAULT_DIMENSION,
                height: dimensions.height || (dimensions.width ? dimensions.width / aspectRatio : null) || DEFAULT_DIMENSION,
            };
        };
        _this.getImageContainerStyle = function () {
            var imageLoaded = _this.state.imageLoaded;
            var _a = _this.props, mediaItem = _a.mediaItem, isSEO = _a.isSEO, dimensions = _a.dimensions, withSSRDimensions = _a.withSSRDimensions, withJpgExperiment = _a.withJpgExperiment;
            var ratioDimensions = _this.getDimensions(mediaItem, dimensions);
            return imageLoaded || isSEO
                ? {}
                : {
                    backgroundImage: "url(" + _this.getMediaUrl(mediaItem, withSSRDimensions ? ratioDimensions : null, true, withJpgExperiment) + ")",
                };
        };
        _this.getImage = function () {
            var _a;
            var _b = _this.props, imageMode = _b.imageMode, _c = _b.className, className = _c === void 0 ? {} : _c, mountedToDOM = _b.mountedToDOM, productName = _b.productName, _d = _b.altText, altText = _d === void 0 ? '' : _d, dimensions = _b.dimensions, mediaItem = _b.mediaItem, _e = _b.imgDataHook, imgDataHook = _e === void 0 ? DataHook.imgDataHook : _e, isSEO = _b.isSEO, _f = _b.hasFixedSize, hasFixedSize = _f === void 0 ? true : _f, _g = _b.withSrcSet, withSrcSet = _g === void 0 ? false : _g;
            var ratioDimensions = _this.getDimensions(mediaItem, dimensions);
            var imageClass = classNames([
                (_a = {},
                    _a[s.imageBeforeMounted] = !mountedToDOM && !isSEO,
                    _a[s.imageModeFit] = imageMode === 2 /* FIT */,
                    _a[s.imageModeCrop] = imageMode === 1 /* CROP */,
                    _a),
                className,
            ]);
            // noinspection JSRedeclarationOfBlockScope
            var getResizedImageUrl = _this.getMediaUrl;
            return (React.createElement(WixMedia, { hasFixedSize: hasFixedSize, imgDataHook: imgDataHook, className: imageClass, widthDimension: ratioDimensions.width, heightDimension: ratioDimensions.height, wixMediaFetcher: { getResizedImageUrl: getResizedImageUrl }, mediaItem: mediaItem, alt: altText || productName, onLoad: _this.onImageLoad, withSrcSet: withSrcSet }));
        };
        return _this;
    }
    ProductImage.prototype.render = function () {
        var _a;
        var _b = this.props, imageMode = _b.imageMode, mountedToDOM = _b.mountedToDOM, _c = _b.containerDataHook, containerDataHook = _c === void 0 ? DataHook.containerDataHook : _c, isSEO = _b.isSEO;
        var imageContainerClass = classNames([
            s.imageContainer,
            (_a = {},
                _a[s.imageContainerModeFit] = imageMode === 2 /* FIT */,
                _a[s.imageContainerModeCrop] = imageMode === 1 /* CROP */,
                _a),
        ]);
        return (React.createElement("div", { "data-hook": containerDataHook, style: this.getImageContainerStyle(), className: imageContainerClass }, (mountedToDOM || isSEO) && this.getImage()));
    };
    return ProductImage;
}(React.Component));
export { ProductImage };
//# sourceMappingURL=ProductImage.js.map